// extracted by mini-css-extract-plugin
export default {"bottom-blinker":"BottomBlinker_bottom-blinker__T3ZLT","blinker":"BottomBlinker_blinker__Pm6hW"};